module.exports = __webpack_public_path__ + "img/Marine.9ce8aa63.png";